import { useEffect } from 'react';

export const useCallsSummaryData = getCallsSummaryRequest => {
    useEffect(() => {
        const timer = setInterval(() => getCallsSummaryRequest(), 3e4);

        return () => clearInterval(timer);
    }, []);
};
